import { getComponentFromName } from '@folklore/utils';

import * as Components from './components';

type RemaxAnimationProps = {
    kind?: string | null;
    [key: string]: unknown;
};

function RemaxAnimation({ kind = null, ...otherProps }: RemaxAnimationProps) {
    const Component = getComponentFromName(Components, kind, null);
    return Component !== null ? <Component {...otherProps} /> : null;
}

export default RemaxAnimation;
